// @flow
// resolve false on the server, use fetch when on the client.
// This needs to be evaluated before isDecodeSafe is called in order to avoid a pop-up blocker.
const response =
  SERVER || typeof fetch === 'undefined'
    ? Promise.resolve(false)
    : fetch('/static/decodeKey.txt', {
        method: 'HEAD',
        redirect: 'error',
        credentials: 'same-origin',
      })
        .then(res => !!res.ok)
        .catch(() => false);

const isDecodeSafe = () => response;

export default isDecodeSafe;
